import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Card,
  Dropdown,
  TextArea,
  Form,
  Input,
  Modal,
} from "semantic-ui-react";
import { GlobalContext } from "../contexts";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { api, currencyRate } from "../config";
const pricingOptions = [
  { key: "month_1_price", text: "1 Month", value: "month_1_price" },
  { key: "month_3_price", text: "3 Months", value: "month_3_price" },
  { key: "month_6_price", text: "6 Months", value: "month_6_price" },
  { key: "month_12_price", text: "1 Year", value: "month_12_price" },
  { key: "lifetime", text: "Lifetime", value: "lifetime" },
];

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}
function Payment() {
  const { user, userData } = useContext(GlobalContext);
  const query = useQuery();
  const [product, setProduct] = useState(null);
  const [email, setEmail] = useState(null);
  const [pricing, setPricing] = useState(
    query.get("package") || "month_12_price"
  );
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    axios.get(api + "get_product?id=" + query.get("pid")).then(({ data }) => {
      setProduct(data);
    });
  }, []);
  const checkoutPaypal = () => {
    !user && setModal(true);
    if (user) {
      setLoading(true);
      axios
        .get(
          api +
            `create_checkout?pid=${product.key}&package=${pricing}&email=${user.email}`
        )
        .then(({ data }) => {
          window.location.href = data.paymentUrl;
        });
    }
  };
  const checkoutPaypalWithEmail = () => {
    setLoading(true);
    axios
      .get(
        api +
          `create_checkout?pid=${product.key}&package=${pricing}&email=${email}`
      )
      .then(({ data }) => {
        window.location.href = data.paymentUrl;
      });
  };
  let finalPrice = 0;
  if (pricing && product && product[pricing]) finalPrice = product[pricing];
  return (
    <div className="container checkout" style={{height:"80vh",overflow:"auto"}}>
      <Card color="orange" style={{ margin: "0px auto" }}>
        <Card.Header
          style={{
            color: "black",
            fontSize: 20,
            padding: "10px 20px",
            fontWeight: "bold",
            color: "#f2711c",
            fontFamily: "Lato",
          }}
        >
          CHECKOUT NOW!
        </Card.Header>
        <Card.Content>
          <div
            style={{
              fontWeight: "bold",
              color: "black",
              fontSize: "1.2rem",
            }}
          >
            Product: {product && product.name}
          </div>

          <div style={{ color: "black", marginTop:  5 }}>
            Choose your package:{" "}
            <Dropdown
              style={{ margin: "7px 0" }}
              fluid
              selection
              value={pricing}
              onChange={(e, data) => setPricing(data.value)}
              options={pricingOptions}
            ></Dropdown>
          </div>
          <div
            style={{
              color: "black",
              marginTop: 7,
              fontWeight: "bold",
              color: "#f2711c",
              fontSize: 20,
              marginBottom: 9,
            }}
          >
            Total: ${pricing && product && product[pricing]}
          </div>
          <Button loading={loading} onClick={checkoutPaypal} color="orange">
            CHECKOUT USING PAYPAL
          </Button>
          <div style={{ color: "black", margin:"5px 0"}}>OR</div>
          <Form style={{padding:0}}>
            <TextArea
              rows={8}
              value={`----------BANK TRANSFER----------\r\nNominal Transfer: ${
                currencyRate * finalPrice
              } IDR\r\nNama: Fandi\r\nNo Rekening: 8895045078\r\nNama Bank: BCA\r\nSilahkan Transfer Sesuai dengan nominal diatas,lalu konfirmasi melalui tombol dibawah ini! `}
            />
			
          </Form>
		  <Button style={{margin:"0 auto", marginTop:7}} color="orange" onClick={()=>window.open(`https://wa.me/6281929530379/?text=Halo%20Kak%2C%20Saya%20ingin%20konfirmasi%20pembayaran%20%3A%0ANama%20Produk%20%3A%20 ${product && product.name} %0APaket%20%3A%20 ${pricingOptions.find(p=>p.key===pricing)?.text} %0AJumlah%20transfer%20%3A%20Rp. ${currencyRate * finalPrice} %0ABukti%20transfer%20terlampir`)}>
            CONFIRM YOUR PAYMENT
          </Button>
        </Card.Content>
      </Card>
      <Modal size="mini" open={modal} onClose={() => setModal(false)}>
        <Modal.Header>You're not logged in!</Modal.Header>
        <Modal.Content
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Input
            style={{ width: "100%" }}
            value={email}
            onChange={(e, data) => setEmail(data.value)}
            placeholder="Please enter your email to continue checkout!"
          ></Input>
          <Button
            style={{ margin: "10px auto" }}
            onClick={checkoutPaypalWithEmail}
            loading={loading}
            color="orange"
          >
            CONTINUE
          </Button>
          <div
            style={{
              color: "black",
              textAlign: "center",
              color: "#f2711c",
              marginTop: "5px",
            }}
          >
            You could create your account or login later after completing
            checkout
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
}
export default Payment;
